import { Box, Text, useTheme } from "@chakra-ui/react";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Quiz } from "../../models/Quiz";

type Props = {
  quiz: Quiz;
  index: number;
};

export default function QuizItem({ quiz, index }: Props) {
  const theme = useTheme();
  const navigate = useNavigate();
  const submissionId = useMemo(() => quiz.submissionId, [quiz.submissionId]);

  const onClick = useCallback(() => {
    navigate(`./quizzes/${quiz.id}`, { state: { submissionId } });
  }, [navigate, quiz.id, submissionId]);

  return (
    <Box
      cursor={"pointer"}
      width={9}
      height={9}
      display="flex"
      justifyContent="center"
      alignItems="center"
      transform={"rotate(45deg) scale(0.8)"}
      bg={submissionId ? theme.colors.primary.DEFAULT : "white"}
      borderColor={!submissionId ? "gray.300" : theme.colors.primary.DEFAULT}
      borderWidth={2}
      borderRadius={4}
      onClick={onClick}
    >
      <Text
        transform={"rotate(-45deg) scale(1.2)"}
        as="span"
        color={submissionId ? "white" : "gray.700"}
        fontSize="md"
      >
        {index}
      </Text>
    </Box>
  );
}
